import { lightTheme } from "../../theme/theme";
type Theme = typeof lightTheme;

export const OurWorkStyles = (theme: Theme) => {
  const accent = `var(--accent, ${theme.primary})`;

  return {
    hero: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: "10px 16px 8px",
    },

    gridWrap: { maxWidth: 1140, margin: "16px auto 40px", padding: "0 16px" },

    filterRow: {
      display: "flex",
      gap: 8,
      flexWrap: "wrap" as const,
      marginBottom: 16,
    },
    filterBtn: {
      fontFamily: '"Poppins", serif',
      cursor: "pointer",
      userSelect: "none" as const,
      borderRadius: 999,
      padding: "8px 12px",
      border: `1px solid ${accent}44`,
      background: `${accent}0F`,
      color: theme.text,
      fontWeight: 600,
      fontSize: 14,
      transition:
        "background-color .2s ease, border-color .2s ease, opacity .2s ease",
    },
    filterBtnActive: {
      background: accent,
      borderColor: accent,
      color: theme.hoverText,
    },

    cardHover: {
      transform: "translateY(-4px)",
      boxShadow: "0 14px 30px rgba(0,0,0,0.12)",
      borderColor: `${accent}55`,
    },

    previewWrap: {
      position: "relative" as const,
      overflow: "hidden",
      aspectRatio: "16 / 9",
      background: `${accent}0F`,
    },
    preview: {
      width: "100%",
      height: "100%",
      objectFit: "cover" as const,
      display: "block",
      transform: "scale(1)",
      transition: "transform .5s ease",
    },

    previewHover: {
      transform: "scale(1.06)",
    },

    previewMask: {
      content: '""',
      position: "absolute" as const,
      inset: 0,
      background:
        "linear-gradient(180deg, rgba(0,0,0,0.00) 55%, rgba(0,0,0,0.06) 100%)",
      pointerEvents: "none" as const,
    },

    body: {
      padding: 16,
      display: "flex",
      flexDirection: "column" as const,
      gap: 10,
    },

    cardTitle: {
      fontWeight: 800,
      fontSize: 18,
      lineHeight: 1.25,
      letterSpacing: 0.2,
    },

    metaRow: {
      display: "flex",
      gap: 12,
      flexWrap: "wrap" as const,
      fontSize: 13,
      opacity: 0.9,
    },

    blurb: {
      fontSize: 14,
      opacity: 0.92,
      lineHeight: 1.5,
    },

    statsRow: {
      display: "flex",
      gap: 10,
      flexWrap: "wrap" as const,
      marginTop: 6,
    },
    statPill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "6px 10px",
      borderRadius: 999,
      background: `${accent}0F`,
      border: `1px solid ${accent}33`,
      fontSize: 12,
      fontWeight: 700,
    },
  };
};
